import React from "react";
import { Box } from "@chakra-ui/react";
import { ExternalLinkProps } from "./ExternalLink.types";

const openUrl = (url: string, target?: string) => {
  const urlToOpen = url.includes("http") ? url : `//${url}`;
  window.open(urlToOpen, target);
};

export const ExternalLink = React.forwardRef<HTMLDivElement, ExternalLinkProps>(
  ({ children, href, target, ...rest }, ref) => {
    return (
      <Box
        display="inline-block"
        _hover={{ cursor: "pointer" }}
        {...rest}
        ref={ref}
      >
        <Box
          onClick={(e) => {
            e.preventDefault();
            openUrl(href, target);
          }}
        >
          {children}
        </Box>
      </Box>
    );
  },
);

ExternalLink.displayName = "ExternalLink";
